import { useSuspenseQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

type ListingView = {
  date: Date
  count: number
}

export function useListingViews({ listingId, period }: { listingId: string; period: string }) {
  return useSuspenseQuery({
    queryKey: ['insights', 'views', listingId, period],
    queryFn: () =>
      client.get(`/stats/listings/${listingId}/${period}`, {
        query: {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      }) as Promise<ListingView[]>,
    refetchInterval: 1000 * 60 * 5
  })
}
